import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import type { EPLITrainerDevelopmentPlan } from '../models/EPLITrainerDevelopmentPlan'
import type { AddEPLITrainerDevelopmentPlanRequest, UpdateEPLITrainerDevelopmentPlanRequest } from '../models/requestObjects/priorityOne/epliTrainerDevelopmentPlanRequestObjects'

const BASE_URL = 'EPLITrainerDevelopmentPlan'

export async function AddEPLITrainerDevelopmentPlan (plan: AddEPLITrainerDevelopmentPlanRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Add`, plan)
}

export async function UpdateEPLITrainerDevelopmentPlan (plan: UpdateEPLITrainerDevelopmentPlanRequest): Promise<Response> {
  return await sendPost(`${BASE_URL}/Update`, plan)
}

export async function DeleteEPLITrainerDevelopmentPlan (epliTrainerDevelopmentPlanId: number, isUpdate?: boolean, implementationPhase?: boolean): Promise<Response> {
  const isUpdateParam = isUpdate !== undefined ? `&&isUpdate=${String(isUpdate)}` : ''
  const implementationPhaseParam = implementationPhase !== undefined ? `&&implementationPhase=${String(implementationPhase)}` : ''
  return await sendPost(`${BASE_URL}/Delete?epliTrainerDevelopmentPlanId=${epliTrainerDevelopmentPlanId}${isUpdateParam}${implementationPhaseParam}`, {})
}

export async function GetEPLITrainerDevelopmentPlan (epliTrainerDevelopmentPlanId: number): Promise<Response<EPLITrainerDevelopmentPlan>> {
  return await sendGet(`${BASE_URL}/Get?epliTrainerDevelopmentPlanId=${epliTrainerDevelopmentPlanId}`)
}

export async function GetEPLITrainerDevelopmentPlans (priorityId: number, contractOnly: boolean): Promise<Response<EPLITrainerDevelopmentPlan[]>> {
  return await sendGet(`${BASE_URL}/GetAll?priorityId=${priorityId}&&contractOnly=${String(contractOnly)}`)
}
